var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-red"},[_vm._v(" Developer only access ")])
}
var staticRenderFns = []

export { render, staticRenderFns }